import un from 'underscore'

export default {
  statusChangeResponse: function(newStatus, quantity) {
    const availabile = 1
    const soldOut = 3
    if (newStatus === availabile && quantity === 0) {
      // Podaj ilość dostępnych produktów
      return 1
    }
    if (newStatus === soldOut && quantity > 0) {
      // Zmieniasz produkt na wyprzedany, zmienic ilość na zero?
      return 2
    }
    return 0
  },
  validateProducAvailabilies(producAvailabilies) {
    return un.chain(producAvailabilies)
      .filter((val) => {
        const res = this.statusChangeResponse(parseInt(val.status), parseInt(val.quantity))
        return res !== 0
      })
      .map((val) => {
        const res = this.statusChangeResponse(parseInt(val.status), parseInt(val.quantity))
        let text = 0
        if (res === 1) {
          return `Podaj ilość produktów dla ${val.name}`
        }
        if (res === 2) {
          return `Zmień na 0 ilość produktów dla ${val.name}`
        }
        return 0
      })
      .filter((val) => {
        return val
      })
      .value()
  }
}



// WEBPACK FOOTER //
// ./src/utils/StatusUtils.js